import { makeStyles } from '@material-ui/core/styles'

const useAccountLinkRowStyles = makeStyles(theme => ({
  link: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 2.5),
    borderRadius: 12,
    backgroundColor: '#F4F7F9',
    color: 'inherit',
    textDecoration: 'none',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: '#ECEFF1',
    },
  },
  iconWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    borderRadius: '50%',
    backgroundColor: '#E0EAFF',
    flexShrink: 0,
    '& .MuiSvgIcon-root': {
      fontSize: 22,
      color: '#0053FF',
    },
    '& svg': {
      width: 22,
      height: 22,
      color: '#0053FF',
      fill: '#0053FF',
    },
  },
  copy: {
    flex: '1 1 auto',
    minWidth: 0,
  },
  title: {
    fontWeight: 700,
    fontSize: '0.9375rem',
    lineHeight: 1.3,
    color: '#00205B',
    marginBottom: theme.spacing(0.5),
  },
  caption: {
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
  },
  chevron: {
    color: '#9EA7B0',
    flexShrink: 0,
  },
}))

export default useAccountLinkRowStyles
